import { useState, useMemo } from 'react';
import { createContext } from 'react';
import { LayoutProps, LayoutStateProps } from './types';
import theme from '~theme';

const LayoutContext = createContext<LayoutProps>({} as LayoutProps);

function LayoutProvider({ children }: { children: React.ReactNode }) {
  const [Layout, setLayout] = useState<LayoutStateProps>({
    header: {
      position: 'right',
    },
    container: {
      paddingLeft: theme.spacing.km12,
      paddingRight: theme.spacing.km12,
    },
  });

  const value = useMemo<LayoutProps>(
    () => ({ ...Layout, setLayout }),
    [Layout]
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
}

export { LayoutContext };
export default LayoutProvider;
